module.exports = __webpack_public_path__ + "img/ma.ee69ba5c.png";